import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { Pending, Rejected, Blocked } from './StatusPages';
import { MEMBER_STATUS } from '../../utils/constants';

/**
 * Gate für den Mitgliederbereich. Nur freigegebene Mitglieder kommen durch -
 * alle anderen sehen eine erklärende Seite statt einer 404 oder eines
 * stillen Redirects.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading, memberStatus, isAdmin, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="mt-loading">
        <div className="mt-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admins bekommen keinen Status-Gate - immer Vollzugang
  if (!isAdmin) {
    if (memberStatus === MEMBER_STATUS.REJECTED) return <Rejected />;
    if (memberStatus === MEMBER_STATUS.BLOCKED) return <Blocked onLogout={logout} />;
    if (memberStatus !== MEMBER_STATUS.ACTIVE) return <Pending onLogout={logout} />;
  }

  return children;
}
